import React from 'react';
import Timeline from './components/ui/Timeline';

const data = [
    {
        title: "Sports Digitale",
        content: "Türkiye'nin dijital spor dünyasında öncü olan ve bağımsız online spor kanalı olarak hizmet veren bir platformdur. Ana amacı, spor tutkunlarına güncel, doğru ve derinlemesine spor haberleri, analizler ve yorumlar sunarak hem taraflı hem de tarafsız bir bakış açısıyla sporun nabzını tutmaktır.",
    },
    {
        title: "İçerik ve Amaç",
        content: "Spor Programları: Canlı yayınlar, maç analizleri ve sporcu röportajları içeren programlar sunar. Özellikle futbol, basketbol ve diğer popüler sporlar üzerinde durarak, seyircilere eğlenceli ve bilgilendirici içerikler sağlar.",
    },
    {
        title: "Haber ve Analiz",
        content: "Transfer haberleri, maç sonuçları, spor kulüpleri hakkında detaylı bilgiler ve lig analizleri gibi konuları kapsar. Hedefi, sporseverlerin bilgiye hızlı ve doğru bir şekilde ulaşmasını sağlamaktır.",
    },
    {
        title: "Bağımsız ve Tarafsız",
        content: "Sports Digitale, içeriğinde tarafsızlığı koruyarak, sporun farklı yönlerini taraflı-tarafsız yorumcular ile değerlendirir. Bu, sporun ruhunu yansıtırken, aynı zamanda her görüşten sporseverin ilgisini çekmeyi amaçlar.",
    }
];

const About = () => {
    return (
        <div className="min-h-screen bg-[var(--bg)]" style={{ paddingTop: 'var(--site-header-h, 3.5rem)' }}>
            <div className="w-11/12 max-w-4xl mx-auto py-16 md:py-20">
                <Timeline data={data} title="Hakkımızda" />
            </div>
        </div>
    );
};

export default About;
